import {
  appApiEndpoint,
  continueCookieName,
  cookieDomain,
  isImpersonatingCookieName,
  isLoggedInCookieName,
} from "@/environment";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import Cookies from "js-cookie";
import api from "@/utils/api";
import log from "loglevel";

export const login = createAsyncThunk("auth/login", async (arg, thunkAPI) => {
  const withCredentials = true;

  try {
    const response = await api.post(
      withCredentials,
      `${appApiEndpoint}/v1/auth/login`,
      {},
      arg
    );
    // localStorage.setItem("isLoggedIn", true);
    // localStorage.removeItem("isImpersonating");
    Cookies.set(isLoggedInCookieName, "true", {
      domain: cookieDomain,
      expires: 365,
    });
    Cookies.remove(isImpersonatingCookieName, {
      domain: cookieDomain,
    });
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const loginGoogle = createAsyncThunk(
  "auth/loginGoogle",
  async (arg, thunkAPI) => {
    const withCredentials = true;

    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/auth/google`,
        {},
        arg
      );
      // localStorage.setItem("isLoggedIn", true);
      // localStorage.removeItem("isImpersonating");
      Cookies.set(isLoggedInCookieName, "true", {
        domain: cookieDomain,
        expires: 365,
      });
      Cookies.remove(isImpersonatingCookieName, {
        domain: cookieDomain,
        expires: 365,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async (arg, thunkAPI) => {
  clearStorage();

  const withCredentials = true;

  try {
    const response = await api.post(
      withCredentials,
      `${appApiEndpoint}/v1/auth/logout`,
      {},
      arg
    );
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (arg, thunkAPI) => {
    const withCredentials = true;

    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/auth/forgot-password`,
        {},
        arg
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetForgotPassword = createAsyncThunk(
  "auth/resetForgotPassword",
  async (arg, thunkAPI) => {
    const withCredentials = true;

    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/auth/forgot-password/reset`,
        {},
        arg
      );
      // localStorage.setItem("isLoggedIn", true);
      // localStorage.removeItem("isImpersonating");
      Cookies.set(isLoggedInCookieName, "true", {
        domain: cookieDomain,
        expires: 365,
      });
      Cookies.remove(isImpersonatingCookieName, {
        domain: cookieDomain,
        expires: 365,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetClaimAccount = createAsyncThunk(
  "auth/resetClaimAccount",
  async (arg, thunkAPI) => {
    const withCredentials = true;

    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/auth/claim-account/reset`,
        {},
        arg
      );
      // localStorage.setItem("isLoggedIn", true);
      // localStorage.removeItem("isImpersonating");
      Cookies.set(isLoggedInCookieName, "true", {
        domain: cookieDomain,
        expires: 365,
      });
      Cookies.remove(isImpersonatingCookieName, {
        domain: cookieDomain,
        expires: 365,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const loadUser = createAsyncThunk(
  "auth/loadUser",
  async (id, thunkAPI) => {
    const withCredentials = true;

    let params = {};
    const isImpersonating = Cookies.get(isImpersonatingCookieName);
    if (isImpersonating === "true") {
      params.isImpersonating = isImpersonating;
    }

    try {
      const response = await api.get(
        withCredentials,
        `${appApiEndpoint}/v1/users/${id}`,
        {},
        params
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const impersonate = createAsyncThunk(
  "auth/impersonate",
  async (arg, thunkAPI) => {
    const withCredentials = true;

    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/auth/impersonate`,
        {},
        arg
      );
      // localStorage.setItem("isLoggedIn", true);
      // localStorage.setItem("isImpersonating", true);
      Cookies.set(isLoggedInCookieName, "true", {
        domain: cookieDomain,
        expires: 365,
      });
      Cookies.set(isImpersonatingCookieName, "true", {
        domain: cookieDomain,
        expires: 365,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const impersonateGet = createAsyncThunk(
  "auth/impersonateGet",
  async (arg, thunkAPI) => {
    const withCredentials = true;

    try {
      const response = await api.get(
        withCredentials,
        `${appApiEndpoint}/v1/auth/impersonate`,
        {},
        arg
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const initialState = {
  user: null,
  userLoading: false,
  loginLoading: false,
  isGoogleLoginLoading: false,
  forgotPasswordLoading: false,
  resetForgotPasswordLoading: false,
  resetClaimAccountLoading: false,
};

const clearStorage = () => {
  // window.sessionStorage.removeItem("continue");
  // localStorage.removeItem("isLoggedIn");
  // localStorage.removeItem("isImpersonating");
  Cookies.remove(continueCookieName, {
    domain: cookieDomain,
  });
  Cookies.remove(isLoggedInCookieName, {
    domain: cookieDomain,
  });
  Cookies.remove(isImpersonatingCookieName, {
    domain: cookieDomain,
  });
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logoutClient(state) {
      clearStorage();
      return initialState;
    },
    clearLoginError(state) {
      delete state["loginError"];
    },
    clearForgotPassword(state) {
      delete state["forgotPasswordAttempted"];
    },
    clearResetForgotPassword(state) {
      delete state["resetForgotPasswordSuccess"];
      delete state["resetForgotPasswordError"];
    },
    clearResetForgotPasswordError(state) {
      delete state["resetForgotPasswordError"];
    },
    clearResetClaimAccount(state) {
      delete state["resetClaimAccountSuccess"];
      delete state["resetClaimAccountError"];
    },
    clearResetClaimAccountError(state) {
      delete state["resetClaimAccountError"];
    },
    clearImpersonateError(state) {
      delete state["impersonateError"];
    },
    clearImpersonateSuccess(state) {
      delete state["impersonateSuccess"];
    },
    invalidateSession(state) {
      state["hasInvalidSession"] = true;
    },
    clearNotifications(state) {
      state["user"]["notifications"] = [];
    },
    setForbidden(state) {
      state["isForbidden"] = true;
    },
    clearForbidden(state) {
      state["isForbidden"] = false;
    },
    updateUserSettings(state, action) {
      // Update user settings in Redux state
      Object.assign(
        state["user"]["employerProfile"]["settings"],
        action.payload
      );
    },
    updateUserProfile(state, action) {
      // Update user profile in Redux state
      Object.assign(state["user"]["profile"], action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, (state, action) => {
        return initialState;
      })
      .addCase(logout.rejected, (state, action) => {
        return initialState;
      })
      .addCase(login.pending, (state, action) => {
        state["loginLoading"] = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state["loginLoading"] = false;
        state["loginSuccess"] = true;
        state["user"] = action.payload;
        state["hasInvalidSession"] = false;
      })
      .addCase(login.rejected, (state, action) => {
        state["loginLoading"] = false;
        state["loginError"] = action.payload;
      })
      .addCase(loginGoogle.pending, (state, action) => {
        state["isGoogleLoginLoading"] = true;
      })
      .addCase(loginGoogle.fulfilled, (state, action) => {
        state["isGoogleLoginLoading"] = false;
        state["loginSuccess"] = true;
        state["user"] = action.payload;
        state["hasInvalidSession"] = false;
      })
      .addCase(loginGoogle.rejected, (state, action) => {
        state["isGoogleLoginLoading"] = false;
        state["loginError"] = action.payload;
      })
      .addCase(forgotPassword.pending, (state, action) => {
        state["forgotPasswordLoading"] = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state["forgotPasswordLoading"] = false;
        state["forgotPasswordAttempted"] = true;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state["forgotPasswordLoading"] = false;
        state["forgotPasswordAttempted"] = true;
      })
      .addCase(resetForgotPassword.pending, (state, action) => {
        state["resetForgotPasswordLoading"] = true;
      })
      .addCase(resetForgotPassword.fulfilled, (state, action) => {
        state["resetForgotPasswordLoading"] = false;
        state["resetForgotPasswordSuccess"] = true;
        state["user"] = action.payload;
        delete state["resetForgotPasswordError"];
        state["hasInvalidSession"] = false;
      })
      .addCase(resetForgotPassword.rejected, (state, action) => {
        state["resetForgotPasswordLoading"] = false;
        state["resetForgotPasswordError"] = action.payload;
        delete state["resetForgotPasswordSuccess"];
      })
      .addCase(resetClaimAccount.pending, (state, action) => {
        state["resetClaimAccountLoading"] = true;
      })
      .addCase(resetClaimAccount.fulfilled, (state, action) => {
        state["resetClaimAccountLoading"] = false;
        state["resetClaimAccountSuccess"] = true;
        state["user"] = action.payload;
        delete state["resetForgotPasswordError"];
        state["hasInvalidSession"] = false;
      })
      .addCase(resetClaimAccount.rejected, (state, action) => {
        state["resetClaimAccountLoading"] = false;
        state["resetClaimAccountError"] = action.payload;
        delete state["resetForgotPasswordSuccess"];
      })
      .addCase(loadUser.pending, (state, action) => {
        state["userLoading"] = true;
      })
      .addCase(loadUser.fulfilled, (state, action) => {
        state["user"] = action.payload;
        state["userLoading"] = false;
        state["hasInvalidSession"] = false;
      })
      .addCase(loadUser.rejected, (state, action) => {
        state["loadUserError"] = action.payload;
        state["userLoading"] = false;
      })
      .addCase(impersonate.pending, (state, action) => {
        state["impersonating"] = true;
        state["impersonateSuccess"] = false;
        state["impersonateError"] = false;
      })
      .addCase(impersonate.fulfilled, (state, action) => {
        state["impersonating"] = false;
        state["impersonateSuccess"] = true;
        state["impersonateError"] = false;
      })
      .addCase(impersonate.rejected, (state, action) => {
        state["impersonating"] = false;
        state["impersonateSuccess"] = false;
        state["impersonateError"] = action.payload.response.data;
      })
      .addMatcher(
        (action) => action.type === "employers/updateSettings/fulfilled",
        (state, action) => {
          const settings = action.payload;
          Object.assign(state["user"]["employerProfile"]["settings"], settings);
        }
      );
  },
});

export const {
  logoutClient,
  clearLoginError,
  clearForgotPassword,
  clearResetForgotPassword,
  clearResetForgotPasswordError,
  clearResetClaimAccount,
  clearResetClaimAccountError,
  clearImpersonateError,
  clearImpersonateSuccess,
  invalidateSession,
  clearNotifications,
  setForbidden,
  clearForbidden,
  updateUserSettings,
  updateUserProfile,
} = authSlice.actions;

export default authSlice.reducer;
